// Video source files are too large for Git and should not be bundled with the build.
// They are hosted on Firebase Storage (project: quantum-flo-auto-algo-d3c2b) instead.

export const INTRO_VIDEO_URL =
  'https://firebasestorage.googleapis.com/v0/b/quantum-flo-auto-algo-d3c2b.firebasestorage.app/o/video%2Fintro.mp4?alt=media&token=3279b2fe-6d86-4029-8a37-e88baebe47bf';

export const RISK_VIDEO_URL =
  'https://firebasestorage.googleapis.com/v0/b/quantum-flo-auto-algo-d3c2b.firebasestorage.app/o/video%2Frisk.mp4?alt=media&token=769779A5-750F-4669-9518-CDB8C3BB8E1D';
